import { defineStore } from "pinia";
import { commClient } from "fw4-library";
import { IKeyValue } from "@appstore/store";
import { IFileData } from "fw4-library";
import { i18n } from "@app/i18n";

export interface IPogodba {
    PogodbaId: number;
    StatusPogodbe: PogodbaStatus;
    Vrednost: number;
    Produkt: string;
    ProduktTip: string;
    Stranka: string;
    Vneseno: string;
    Poslovalnica: string;
    IsIdentified: boolean;
    StPogodbe: string;
    StRacuna: string;
    StKomentarjev: number;
    VsehKomentarjev: number;
    SignType: string;
    Rocnost: number;
    DavcnaSt: number;
    Vnesel: string;
    ShowCompleteContract: boolean;
    IsAnonymized: boolean;
}

export interface ICounts{
    ContractCount: number;
    ForProcessingCount: number;
    NotReadCount: number;
}

export interface IPogodbaData{
    Counts: ICounts;
    // ContractCount: number;
    MoreData: boolean;
    ContractList: IPogodba[];
    // ForProcessingCount: number;
    currentContractId: number;
    showEditContract: boolean;
}

export interface IPagination {
    PageSize: number,
    PageIndex: number
}

export enum ContractTabStatus {
    All = "A",
    ForProcessing = "FP",
    Processed = "P",
    NotRead = 'NR'
}

export interface IPogodbaFilters{
    Search: string;
    DateRange: Array<Date> | null;
    // Status: IKeyValue | undefined;
    Status: [];
    // Status: PogodbaStatus[];
    PoslovalnicaFilter: IKeyValue | undefined;
    Pagination: IPagination;
    SortDirection: SortDirection;
    ContractTabStatus: ContractTabStatus;
}

export interface IPogodbaCommentFile{
    FileId: string;
    FileName: string;
    Status: string
}

export interface IPogodbaKomentar {
    Komentar: string;
    Initials: string;
    Uporabnik: string;
    Datum: string;
    Status: string;
    Prejemnik: string;
    Datoteke: IPogodbaCommentFile[];
}

export interface IPogodbaDokument {
    key: string;
    naziv: string;
    opis: string;
    obvezen: boolean;
    stranka: boolean;
    nalozen: boolean;
}

export interface IPogodbaDetails {
    PogodbaId: number;
    StatusPogodbe: PogodbaStatus | null;
    Produkt: string;
    StRacuna: string;
    Znesek: number;
    Stranka: string;
    Vneseno: string;
    Vnesel: string;
    Poslovalnica: string;
    Komentarji: IPogodbaKomentar[];
    Dokumenti: IPogodbaDokument[];
    StPogodbe: string;
    EPodpisKoncan: boolean;
    ShowCompleteContract: boolean;
    DavcnaSt: string;
    Rocnost: number;
    Dokumentacija: string;
    Podpis: string;
    StornoComment: string;
    NoDoc: boolean;
}

export enum AttachedDocType {
    POS_INVOICE = 'POS_INVOICE',
    OTHER = 'OTHER',             
}
export interface IPogodbaCommentNew {
    Comment: string;
    Files: IFileData[];
    FileType: AttachedDocType | null;
}

export enum PogodbaStatus {
    VOdobravanju = 100,
    NezakljucenPodpis = 110,
    PotrebnaIdentifikacija = 120,
    Odobreno = 130,
    Zavrnjeno = 140,
    Zakljuceno = 150,
    Storno = 160,
    CakaStorno = 170
}

export enum SortDirection {
    Newest = 'DESC',
    Oldest = 'ASC',
}

export interface IPogodbaESignLater {
    showPodpis: boolean;
    Url: string;
    type: string;
}

export enum Interval {
    Year = "Y",
    Month = "M",
    Week = "W"
}

export interface IDashStats{
    ContractCount: number;
    Interval: Interval;
    Trend: string;
    PercentVal: number;
    Unread: number;
    ForProcessing: number;
}

export interface IHelpers {
    ShowRefreshLoader: boolean;
    ShowLoadLoader: boolean;
    ShowCommentsLoader: boolean;
}

interface ISeznamPogodbState{
    Filters: IPogodbaFilters;
    PogodbaData: IPogodbaData;
    PogodbaPlacane: IPogodba[];
    PogodbaNeplacane: IPogodba[];
    // PogodbaSeznam: IPogodba[];
    PogodbaDetails: IPogodbaDetails;
    ChosenDocuments: String[];
    CommentNew: IPogodbaCommentNew;
    ESignLater: IPogodbaESignLater;
    PoslovalnicaList : IKeyValue[];
    DashStats: IDashStats;
    Helpers: IHelpers;
}

export function ResetFilters() : IPogodbaFilters {
    return { 
        Search: "",
        DateRange: null, 
        Status: [],
        PoslovalnicaFilter: undefined,
        Pagination: {
            PageIndex: 1,
            PageSize: 50
        },
        SortDirection: SortDirection.Newest,
        ContractTabStatus: ContractTabStatus.All
    };
}

export const useSeznamPogodbStore = defineStore("seznamPogodb", {
    state: (): ISeznamPogodbState => {
        return {
            Filters: ResetFilters(),
            PogodbaPlacane: [],
            PogodbaNeplacane: [],
            // PogodbaSeznam: [],
            PogodbaDetails: {
                PogodbaId: -1,
                StatusPogodbe: null,
                Produkt: "",
                StRacuna: "",
                Znesek: -1,
                Stranka: "",
                Vneseno: "",
                Vnesel: "",
                Poslovalnica: "",
                Komentarji: [],
                Dokumenti: [],
                NoDoc: true,
                StPogodbe: "",
                EPodpisKoncan: false,
                ShowCompleteContract: false,
                DavcnaSt: "",
                Rocnost: 0,
                Dokumentacija: "",
                Podpis: "",
                StornoComment: ""
            
            },                
            ChosenDocuments: []   ,
            CommentNew: {
                Comment: "",
                Files: [],
                FileType: null
            },
            ESignLater: {
                showPodpis: false,
                Url: "",
                type: ""
            },
            PoslovalnicaList: [],
            PogodbaData: {
                Counts: {
                    ContractCount: 0,
                    NotReadCount: 0,
                    ForProcessingCount: 0
                },
                // ContractCount: 0,
                MoreData: false,
                ContractList: [],
                // ForProcessingCount: 0
                currentContractId: 0,
                showEditContract: false
            
            },
            DashStats: {
                ContractCount: 0,
                Interval: Interval.Year,
                Trend: '',
                PercentVal: 0,
                Unread: 0,
                ForProcessing: 0,
            },
            Helpers: {
                ShowRefreshLoader: false,
                ShowLoadLoader: false,
                ShowCommentsLoader: false
            }
        }
    },
    actions: {
        async pogodbaPodpisLater(type: string) {
            const uploadPogodbaCompleteLater = (Message: any): void => {
                if (Message) {  
                    if(Message.Success){
                        this.ESignLater.Url = Message.Url;
                    }
                    else{
                        alert("Napaka pri prenosu dokumentov.");
                    }
                }
                else {
                }
            }
            this.ESignLater.type = type;
            this.ESignLater.showPodpis = true;
            this.ESignLater.Url = "/StaticLoaders/upload_wait.html";

            commClient.OnStreamDataReceived.ClearCallbacks();
            commClient.OnStreamDataReceived.AddCallback(this.signComplete);
            
            commClient.executeMethod("ContractESignLater", { 
                //PogodbaId: 140620,
                PogodbaId: this.PogodbaDetails.PogodbaId
            }, uploadPogodbaCompleteLater);
        },

        signComplete(Message: any){
            if(Message && Message[0] && Message[0].Success){
                if (Message[0].Status == "complete") {
                    if (this.ESignLater.type == "seznam") {
                        this.getPogodbeSeznam();
                    } else {
                        this.getPogodbaDetails(this.PogodbaDetails.PogodbaId);
                    }
                    this.ESignLater.showPodpis = false;
                    this.ESignLater.Url = "";
                    this.ESignLater.type = "";
                    // reload?
                }
            }  else {
                //alert("Napaka pri podpisu.");
            }

            commClient.OnStreamDataReceived.RemoveCallback(this.signComplete);
        },

        async LoadDashData() {
            const loadComplete = (Message: any): void => {
                if (Message) {
                    this.DashStats = Message as IDashStats;
                } else {
                }
            };

            commClient.executeMethod("sf.DashStatsLoad", {}, loadComplete);
        },

        // async getPoslovalnica() {
        //     const getComplete = (Message: any): void => {
        //         if (Message) { 
        //             this.PogodbaDetails = Message as IKeyValue[];
        //         } 
        //     };

        //     commClient.executeMethod("sf.PoslovalnicaLoad", {
        //     }, getComplete);            
        // },

        // async getPogodbaPlacane(filters: IPogodbaFilters) {
        //     const getComplete = (Message: any): void => {
        //         if (Message) { 
        //             this.PogodbaPlacane = Message as IPogodba[];
        //         } 
        //         else {

        //         }
        //     };

        //     commClient.executeMethod("sf.PogodbaListPlacane", {
        //         DateStart: filters.DateRange ? filters.DateRange[0] : null,
        //         DateEnd: filters.DateRange ? filters.DateRange[1] : null,
        //         Search: filters.Search
        //     }, getComplete);
        // },

        // async getPogodbaNePlacane(filters: IPogodbaFilters) {
        //     const getComplete = (Message: any): void => {
        //         if (Message) { 
        //             this.PogodbaNeplacane = Message as IPogodba[];
        //         } 
        //         else {

        //         }
        //     };

        //     commClient.executeMethod("sf.PogodbaListNeplacane", {
        //         DateStart: filters.DateRange ? filters.DateRange[0] : null,
        //         DateEnd: filters.DateRange ? filters.DateRange[1] : null,
        //         Search: filters.Search,
        //         Status: JSON.stringify(filters.Status),
        //         PoslovalnicaFilter: filters.PoslovalnicaFilter == undefined ? -1 : filters.PoslovalnicaFilter.Key 
        //     }, getComplete);            
        // },
    
        async getPogodbeSeznam() {
            const getComplete = (Message: any): void => {
                setTimeout(() => {
                    this.Helpers.ShowLoadLoader = false;
                    this.Helpers.ShowRefreshLoader = false;
                }, 2200);

                if (Message) { 
                    Object.assign(this.PogodbaData, Message)

                    // console.log("LEN: " + this.PogodbaData.ContractList.length);
                    // this.PogodbaSeznam = Message.ContractList as IPogodba[];
                } 
                else {

                }
            };
            
            // console.log("PageSize: " + this.Filters.Pagination.PageSize)
            // console.log("PageIndex: " + this.Filters.Pagination.PageIndex)

            // console.log(this.Filter

            commClient.executeMethod("sf.PogodbaList", {
                DateStart: this.Filters.DateRange ? this.Filters.DateRange[0] : null,
                DateEnd: this.Filters.DateRange ? this.Filters.DateRange[1] : null,
                Search: this.Filters.Search == null ? "" : this.Filters.Search,
                PageSize: this.Filters.Pagination.PageSize,
                PageIndex: this.Filters.Pagination.PageIndex,
                Status: JSON.stringify(this.Filters.Status),
                SortDirection: this.Filters.SortDirection,
                PoslovalnicaFilter: this.Filters.PoslovalnicaFilter == undefined ? -1 : this.Filters.PoslovalnicaFilter.Key,
                ContractTabStatus: this.Filters.ContractTabStatus
            }, getComplete);            
        },
        
        async getPogodbaDetails(PogodbaId: number) {
            const getComplete = (Message: any): void => {
                if (Message) { 
                    Object.assign(this.PogodbaDetails, Message);
                    console.log("PogodbaDetails: ", this.PogodbaDetails);
                } 
            };

            commClient.executeMethod("sf.PogodbaLoad", {
                PogodbaId: PogodbaId
            }, getComplete);            
        },

        async PogodbaStorno() {
            return new Promise((resolve, reject) => {
                const saveComplete = (Message: any): void => {
                    if (Message) {  
                         resolve(true);
                    } else {
                    }
                };

                commClient.executeMethod("ContractStorno", {
                    PogodbaId: this.PogodbaDetails.PogodbaId,
                    Comment: this.PogodbaDetails.StornoComment
                }, saveComplete);
            });  
        },

        async addContractComment(){
            return new Promise((resolve, reject) => {
                const saveComplete = (Message: any): void => {
                    if (Message) {  
                        this.CommentNew = {
                            Comment: "",
                            Files: [],
                            FileType: null
                        };
                        this.PogodbaDetails.Komentarji = Message as IPogodbaKomentar[];

                        this.Helpers.ShowCommentsLoader = false;

                        resolve(true);
                    } else {
                    }
                };

                this.Helpers.ShowCommentsLoader = true;
    
                let uploadFiles: string = "";
                if (this.CommentNew.Files.length > 0) {
                    uploadFiles = this.CommentNew.Files.map((files: { FileId: string }) => files.FileId).join(";")
                }

                commClient.executeMethod("AddContractComment", {
                    UploadedFiles: uploadFiles,
                    PogodbaId: this.PogodbaDetails.PogodbaId,
                    Prejemnik: "PS",
                    Comment: this.CommentNew.Comment,   
                    FileType: this.CommentNew.FileType 
                }, saveComplete);
            });  
        },

        downloadChosenDocuments() {
            console.log(this.ChosenDocuments)
        },

        selectAllDocuments(){
            this.ChosenDocuments = ["soglasjeDirektnaObremenitev", "izjavaPio", "soglasjePogodba", "soglasjeSepa", "izjavaPio2", "soglasjeStvari"]
        },

        async loadPoslovalnica() {
            const loadComplete = (Message: any): void => {
                if (Message) {
                    this.PoslovalnicaList = Message as IKeyValue[]; 
                } else {
                }
            };

            commClient.executeMethod("sf.PoslovneEnoteList", {}, loadComplete);
        },

        getStatusItems() {
            let retVal: IKeyValue[] = [];

            for (let item in PogodbaStatus) {
                if (parseInt(item) == 0 || parseInt(item) > 1) {
                    retVal.push({
                        Key:item,
                        Value: i18n.global.t("ContractStatus." + PogodbaStatus[item]),
                        AdditionalData: {
                            classSelection: `filter__status__list-item tag tag--sm tag--${PogodbaStatus[item]}`
                        }
                    })
                }
            }
            return retVal;
        },
    }
});